exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7231e386].card:target {\n  outline: .5rem solid #f59e0b;\n}\n", ""]);

// exports
